import { addSpaceToNumber } from 'src/Helpers/layoutHelpers'

export const formatCuratorStats = (
  playlistsCount: number,
  followersCount: number,
): string | null => {
  if (playlistsCount === 0 || followersCount === 0) {
    return null
  }

  const playlistText = playlistsCount === 1 ? 'playlist' : 'playlists'
  const playlistsText = `${playlistsCount} ${playlistText}`
  const followersText = `${addSpaceToNumber(followersCount, ',')} followers`

  return `${playlistsText}, ${followersText}`
}
